<!--
    Styles
-->

<style>

    #dashboard .l-zoom {
        position: absolute;
        right: 10px;
        bottom: 20px;
        background: var(--cl-white);
        border: 1px solid var(--cl-gray);
    }

    #dashboard .l-zoom a {
        align-items: center;
        width: 46px;
        height: 46px;
    }
    #dashboard .l-zoom a:first-child {
        border-bottom: 1px solid var(--cl-gray);
    }
    #dashboard .l-zoom a svg {
        width: 20px;
        height: 20px;
    }

</style>



<!--
    Template
-->

<template>
    <div class="l-zoom cl-blue">
        <a class="u-col" @click="zoom(1)">
            <icon-plus />
        </a>
        <a class="u-col" @click="zoom(-1)">
            <icon-minus />
        </a>
    </div>
</template>



<!--
    Scripts
-->

<script>


    import config from '@/common/configs/map'
    import iconPlus from '@/assets/icons/plus.svg'
    import iconMinus from '@/assets/icons/minus.svg'


    export default {

        components: {
            iconPlus,
            iconMinus
        },

        methods: {

            zoom (delta) {
                const query = this.$route.query;
                let zoom = (query.zoom || config.zoom) + delta;
                zoom = Math.max(zoom, config.minZoom);
                zoom = Math.min(zoom, config.maxZoom);
                this.$router.push({
                    name: this.$route.name,
                    query: {...query, zoom}
                })
            }

        }

    }

</script>

